import React from 'react'

import { PhoneNumber } from 'src/refactor/components/IconTextComponent'
import { ItemData } from 'src/context/results/types'

import { TResultListItemProps } from './types'
import {
  RliAddress,
  RliContainer,
  RliDistance,
  RliTitle,
  RliTaxonomy,
} from './ResultListItem.styled'

export const FacilityResultListItem = React.forwardRef<
  HTMLDivElement,
  ItemData & TResultListItemProps
>(
  (
    {
      practiceName,
      distance,
      address1,
      fullAddress,
      phone,
      taxonomyDisplay,
      togglePopup,
      style,
      id,
    },
    ref
  ) => {
    const onHover = () => togglePopup(id)

    return (
      <RliContainer
        ref={ref}
        onMouseEnter={onHover}
        onMouseLeave={onHover}
        style={style}
      >
        <RliTitle role="heading" aria-level={2}>
          {practiceName}
        </RliTitle>
        <RliDistance>{distance} mi</RliDistance>

        {taxonomyDisplay && <RliTaxonomy>{taxonomyDisplay}</RliTaxonomy>}

        <RliAddress>{address1}</RliAddress>
        <RliAddress>{fullAddress}</RliAddress>

        <PhoneNumber number={phone as string} />
      </RliContainer>
    )
  }
)
